// extracted by mini-css-extract-plugin
module.exports = {"map-popover":"map-popover_map-popover__1mBpi","hide":"map-popover_hide__2vvZ6","precinct-name":"map-popover_precinct-name__228eD","county-name":"map-popover_county-name__3Srlq"};